// Re-export the useClientApi hook from ApiProvider
export { useClientApi } from '../components/ApiProvider'
